import React, { useState, useEffect } from 'react'
import { Modal } from '@material-ui/core'
import Api from '../../../pages/api/api'
import styles from './file_details.module.css'
import strings from '../../strings/strings.json'
import VulnerStatistics from '../vulner_statistics'
import FileDetailsTabbar from '../file_details_tabbar/file_details_tabbar'
import { makeStyles } from '@material-ui/core/styles'
import { useRouter } from 'next/router'
import Progress from '../../modules/progress/progress'
import BuyPdfModal from '../../modules/buy_pdf_modal'
import FileDetailsInfo from '../file_details_info'
import * as generalAction from '../../redux/action/general_action'
import { useDispatch } from 'react-redux'
import { Container } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
    root: {
        "& .MuiGrid-root": {
            justifyContent: 'center'
        }
    },
    colorPrimary: {
        color: "#073748",
        marginInlineStart: "20px"
    },
    paper: {
        position: "absolute",
        width: 400,
        backgroundColor: "#ffffff",
        border: 0,
        boxShadow: "0 10px 80px 2px rgba(77, 72, 103, 0.15)",
        padding: theme.spacing(2, 4, 3),
        left: "50%",
        top: "50%",
        outline: 0,
        transform: "translate(-50%, -50%)",
        borderRadius: "15px",
        [theme.breakpoints.down('sm')]: {
            width: 280,
            padding: 10
        }
    },

}))


export default function FileDetails(props) {

    const router = useRouter()
    const dispatch = useDispatch()
    let setIntervalId = null
    const classes = useStyles()
    const state = router.query
    const [data, setData] = useState()
    const [openmodal, setOpenModal] = useState(false)
    const [vulnsWaiting, setVulnsWaiting] = useState(true)
    const [isLoading, setIsLoading] = useState(true)
    const [openBuyPdf, setOpenBuyPdf] = useState(false)



    useEffect(() => {

        if (Object.values(state).length !== 0) {
            callFileDetailApi()
        } else {
            if (state.scan_finished)
                setVulnsWaiting(false)
            else
                doScanAgain()
        }
        return () => {
            clearInterval(setIntervalId)
            localStorage.removeItem("lib")
            localStorage.removeItem("low")
            localStorage.removeItem("high")
        }

    }, [state])


    const callFileDetailApi = () => {
        Api.fileDetails({
            "md5": state.details[1]
        })
            .then(result => {
                dispatch(generalAction.setUploaderEmail(result.details.uploader_email_exists))
                setData(result.details)
                setIsLoading(false)
                if (!result.details.scan_finished)
                    doScanAgain()
                else
                    setVulnsWaiting(false)
            })
            .catch(err => {
                props.setSnack(true, "error",
                    <div>
                        <div>{err.message}</div>
                        {
                            err.info !== undefined &&
                            <div>{err.info}</div>
                        }
                    </div>
                )
                router.push('/')
                console.log('err===>file detail', err)
            })
    }

    const doScanAgain = () => {

        setIntervalId = setInterval(() => {
            Api.fileDetails({
                "md5": state.details[1]
            })
                .then(result => {
                    if (result.details.scan_finished) {
                        setData(result.details)
                        clearInterval(setIntervalId)
                        setVulnsWaiting(false)
                    }
                })
                .catch(err => { })
        }, 10000);
    }

    const doRescanHandler = () => {
        if (data && data.file_avail) {
            setOpenModal(false)
            setIsLoading(true)
            Api.reScanFile({
                "hash": data.sha256
            })
                .then(result => {
                    setVulnsWaiting(true)
                    setTimeout(() => {
                        callFileDetailApi()
                    }, 3000);
                })
                .catch(err => {
                    props.setSnack(true, "error",
                        <div>
                            <div>{err.message}</div>
                            {
                                err.info !== undefined &&
                                <div>{err.info}</div>
                            }
                        </div>
                    )
                })

        } else {
            props.setSnack(true, "error", strings.general_fileNotExist)
        }
    }

    const openBuyPdfModalHandler = () => {
        if (props.generalState.userInfo)
            setOpenBuyPdf(true)
        else
            props.setSnack(true, "warning", strings.fileDetails_firstRegister)
    }

    /* const hashCopyHandler = () => {
        navigator.clipboard.writeText(data.sha256)
        props.setSnack(true, "success", strings.general_doneCopy)
    } */

    if (isLoading) return (<Progress css="center_screen" />)

    return (
        <Container>
            <div className="xs:mt-20 sm:mt-20 md:mt-56 lg:mt-56">
                <div className="gradient_blue_background" />
                <div className={styles.file_detail_container}>
                    <FileDetailsInfo data={data} buyPdfHandler={openBuyPdfModalHandler} doRescan={() => setOpenModal(true)} />
                </div >

                <React.Fragment>
                    {
                        !vulnsWaiting &&
                        <VulnerStatistics
                            vulnerabilities={data.vulns_high_count}
                            vulnerability_risk={data.vulns_low_count}
                            vulnerability_rate={data.vulns_rate}
                            vulnerability_libs={data.vulns_lib_count}
                        />
                    }
                    <FileDetailsTabbar data={data} isVulns={vulnsWaiting} />
                    <Modal disableScrollLock={true}
                        open={openmodal}
                    >
                        <div className={classes.paper}>
                            <div className={`${styles.modal_title_container} center`}><span className={styles.modal_title}>{strings.fileDetail_areyouSure}</span></div>
                            <div className="flex flex_center">
                                <div className={styles.btn_yes_container} onClick={() => doRescanHandler()}><button className={`${styles.confirm_btn} ${styles.btn_yes}`}>{strings.general_yes}</button></div>
                                <div className={styles.btn_no_container} onClick={() => setOpenModal(false)}><button className={`${styles.confirm_btn} ${styles.btn_no}`}>{strings.general_no}</button></div>
                            </div>
                        </div>
                    </Modal>
                    {
                        (props.generalState.userInfo ||
                            router.query.app_owner_email) &&
                        <BuyPdfModal
                            open={openBuyPdf}
                            closeModal={() => setOpenBuyPdf(false)}
                            data={data}
                            email={router.query.app_owner_email !== undefined ? router.query.app_owner_email : props.generalState.userInfo.email}
                        />
                    }
                </React.Fragment>
            </div>
        </Container>
    )
}

